module.exports = __webpack_public_path__ + "img/cart-in-outline-300.b034b623.svg";